import {InjectionToken} from '@angular/core';

export const SERVER_URL: InjectionToken<string> = new InjectionToken('Server url');
